/* tslint:disable */
/* eslint-disable */
export enum AccountHolderIdentifierType {
  NATIONAL_ID = 'NATIONAL_ID',
  TAX_ID = 'TAX_ID'
}
